import React from 'react';

const KoiiBlockHeight = () => {
  return <div>API Call 3</div>; // Replace with actual API call
};

export default KoiiBlockHeight;
